"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownMenu = exports.dropdownButton = exports.dropdown = void 0;

var _base = require("./base");

var _swatches = require("../swatches");

var dropdown = {
  bg: _swatches.monochrome.white,
  text: _swatches.monochrome.dark,
  descriptionBg: _swatches.monochrome.light,
  textHover: _swatches.monochrome.black,
  textFocus: _base.primary.brand,
  icon: _base.primary.brand,
  negativeIcon: _base.primary.negative
};
exports.dropdown = dropdown;
var dropdownButton = {
  borderHover: _swatches.monochrome.mediumDark,
  borderFocus: _base.primary.brand,
  prefixText: _swatches.monochrome.mediumDark,
  prefixBg: _swatches.monochrome.light,
  backgroundDisabled: _swatches.monochrome.light
};
exports.dropdownButton = dropdownButton;
var dropdownMenu = {
  itemBgHover: _base.secondary.brand,
  negativeItemBgHover: _base.secondary.negative,
  highlightBg: _swatches.monochrome.superLight
};
exports.dropdownMenu = dropdownMenu;
//# sourceMappingURL=dropdown.js.map